const currencyFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
});

const countFormatter = new Intl.NumberFormat("en-GB");

export const formatCurrency = (value) =>
  currencyFormatter.format(Number(value ?? 0));

export const formatCount = (value) =>
  countFormatter.format(Number(value ?? 0));

export const getTodayInputDate = () =>
  new Date().toISOString().slice(0, 10);

export const parseTillId = (value) => {
  if (!value || value === "all") return null;
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : null;
};

export const buildSummaryRows = ({
  items = [],
  total,
  deductions = [],
  netTotal,
  totalLabel = "Total",
  netLabel = "Net Total",
}) => {
  const rows = items.map((item) => ({
    label: item.label ?? "",
    count: formatCount(item.transaction_count),
    value: formatCurrency(item.total_value),
  }));

  if (total) {
    rows.push({
      label: totalLabel,
      count: formatCount(total.transaction_count),
      value: formatCurrency(total.total_value),
      highlight: true,
      dividerTop: true,
    });
  }

  if (deductions.length > 0) {
    rows.push(
      ...deductions.map((item) => ({
        label: item.label ?? "",
        count: formatCount(item.transaction_count),
        value: formatCurrency(-Math.abs(item.total_value ?? 0)),
      }))
    );
  }

  if (netTotal) {
    rows.push({
      label: netLabel,
      count: formatCount(netTotal.transaction_count),
      value: formatCurrency(netTotal.total_value),
      highlight: true,
      dividerTop: true,
    });
  }

  return rows;
};

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return "";
  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

export const downloadCsv = (fileName, headers, rows) => {
  const lines = [headers, ...rows].map((row) =>
    row.map(escapeCsvValue).join(",")
  );
  const csvContent = `\uFEFF${lines.join("\n")}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const buildReportCsvName = (baseName, date, tillId) => {
  const parts = [baseName];
  if (date) parts.push(date);
  if (tillId) parts.push(`till-${tillId}`);
  return `${parts.join("_")}.csv`;
};
